import React, {useState} from 'react';
import {
   Image,
   ScrollView,
   StyleSheet,
   View,
   Text,
   TextInput,
   TouchableOpacity,
   Modal,
   ActivityIndicator,
   Keyboard,
   TouchableWithoutFeedback,
   SafeAreaView,
   Platform,
   Dimensions,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {
   AUTHDATA,
   FONT_FAMILY_BOLD,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_SEMI_BOLD,
   PAYMENT_PROCESS,
   appBackgroundWhiteBG,
   colorPrimaryError25,
   colorPrimaryError300,
   loginErrorMessage,
   primaryColor500,
   secure_checkout,
   colorPrimaryError600,
   currencyConverter,
   ActivityLoaderColor,
   isWeb,
   isMacOS,
   FREE_COURSE,
   BUTTON_HOVER_COLOR,
   WHITE_TEXT_HOVER_COLOR,
} from '../../utils/utils';
import {ApplicationHeader} from '../../utils/application_header';
import {FONT_FAMILY_REGULAR} from '../../utils/utils';
import {white} from '../../utils/utils';
import {base100} from '../../utils/utils';
import {CopyRightForTab} from '../../utils/CopyRightForTab';
import {CopyRight} from '../../utils/CopyRight';
import {useNavigation, useRoute} from '@react-navigation/native';
import {useEffect} from 'react';
import {retrieveAppData} from '../../utils/preference';
import PaymentAlert from '../../utils/payment_alert';
import {apiPostRequest} from '../../service/network_access';
// import KeyboardAvoidingView from 'react-native/Libraries/Components/Keyboard/KeyboardAvoidingView';
import KeyboardAvoidingView from '../../components/keyboard/KeyboardAvoidingView';
import {Popup} from '../../components/popup';
import {PaymentSteps, PaymentStepsView} from '../../utils/PaymentSteps';
import {GetCardType} from '../../utils/CardUtil';
import CustomAlert from './CustomAlert';
import {isWindows} from 'react-device-detect';
import {setIsDashboardRefreshRequired} from '../../redux/slices/DashboardRefreshSlice';

export const PaymentDetails = () => {
   const Payment_Details = 'Payment Details';
   const Payment_Review = 'Review';
   const Payment_cConfirmation = 'Checkout Confirmation';

   const [cardHolderName, setCardHolderName] = useState('');
   const [cardNumber, setCardNumber] = useState('');
   const [cardMM, setCardMM] = useState('');
   const [cardYY, setCardYY] = useState('');
   const [cardCVV, setCardCVV] = useState('');
   const [userAuthData, setUserAuthData] = useState('');

   const [showAlert, setShowAlert] = useState(false);
   const [alertTitle, setAlertTitle] = useState('');
   const [alertMessage, setAlertMessage] = useState('');
   const [alertButtonText, setAlertButtonText] = useState('');
   const [isAlertTypePositive, setIsAlertTypePositive] = useState(true);
   const [isApiLoading, setIsApiLoading] = useState(false);
   const [paymentStape, setPaymentStep] = useState(0);
   const [isCardNumberError, setIsCardNumberError] = useState(false);
   const [isCardNameError, setIsCardNameError] = useState(false);
   const [isCardExpryError, setIsCardExpiryError] = useState(false);
   const [isCardCvvError, setIsCardCvvError] = useState(false);

   const isLandscapemode = useSelector(selectScreenOrientation);
   const [isFirstNameFocused, setIsFirstNameFocused] = useState(false);
   const [isKeyboardVisible, setKeyboardVisible] = useState(false);
   const mTitle = secure_checkout;
   const courseItem = useRoute().params.curseData;
   const navigation = useNavigation();
   const [windowDimensions, setWindowDimensions] = useState(
      Dimensions.get('window'),
   );
   const [alertMacOSVisible, setAlertMacOSVisible] = useState(false);
   const [alertMacX, setAlertMacX] = useState(0);
   const [alertMacY, setAlertMacY] = useState(0);
   const dispatch = useDispatch();
   const [isFreeCoursePayment, setIsFreeCoursePayment] = useState(false);
   const [paymentTitle, setPaymentTitle] = useState(Payment_Details);

   useEffect(() => {
      const keyboardWillShowListener = Keyboard.addListener(
         Platform.OS === 'android' ? 'keyboardDidShow' : 'keyboardWillShow',
         () => {
            setKeyboardVisible(true);
         },
      );
      retrieveAppData(AUTHDATA)
         .then(value => {
            const jsonObj = JSON.parse(value);
            setUserAuthData(jsonObj);
         })
         .catch(error => {
            logger('error::', error);
         });
      const keyboardDidHideListener = Keyboard.addListener(
         'keyboardDidHide',
         () => {
            setKeyboardVisible(false);
         },
      );
      const handleResize = () => {
         setWindowDimensions(Dimensions.get('window'));
      };
      Dimensions.addEventListener('change', handleResize);
      return () => {
         keyboardWillShowListener.remove();
         keyboardDidHideListener.remove();
         Dimensions.removeEventListener('change', handleResize);
      };
   }, []);

   function infoViewShown(event) {
      setAlertMacX(event.nativeEvent.pageX - 225);
      setAlertMacY(event.nativeEvent.pageY - 180);
      setAlertMacOSVisible(true);
   }

   function infoViewHidden() {
      setAlertMacOSVisible(false);
   }

   useEffect(() => {
      navigation.setOptions({
         title: `${paymentTitle}`,
      });
   }, [paymentTitle]);

   return (
      <KeyboardAvoidingView
         behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
         style={styles.container}>
         <View style={styles.container}>
            <ApplicationHeader
               OnBackPress={() => {
                  navigation.goBack();
               }}
               title={mTitle}
            />
            <View
               style={{
                  backgroundColor: '#001231',
                  paddingHorizontal: 16,
                  paddingVertical: 10,
                  flexDirection: 'row',
                  alignItems: 'center',
                  height: 40,
               }}>
               <Image
                  source={
                     paymentStape >= 2
                        ? require('../../assets/shopping-cart.png')
                        : require('../../assets/card.png')
                  }
                  style={{width: 14, height: 14, tintColor: white}}
               />
               <Text
                  style={{
                     flex: 1,
                     textAlignVertical: 'center',
                     color: white,
                     fontSize: 14,
                     marginLeft: 8,
                     fontWeight: '500',
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  {paymentTitle}
               </Text>
            </View>
            {showAlert &&
               (Platform.OS === 'windows' ? (
                  <Popup
                     isOpen={showAlert}
                     isLightDismissEnabled={true}
                     onDismiss={() => {
                        setShowAlert(false);
                     }}>
                     <PaymentAlert
                        actionPositive={isAlertTypePositive}
                        title={alertTitle}
                        message={alertMessage}
                        buttonText={alertButtonText}
                        onCallBack={alertCallBack}
                     />
                  </Popup>
               ) : Platform.OS === 'macos' ? (
                  <View
                     style={{
                        position: 'absolute',
                        zIndex: 20,
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1,
                        backgroundColor: 'rgba(0,0,0,0.9001)',
                        width: '100%',
                        height: '100%',
                     }}>
                     <View
                        style={{
                           backgroundColor: 'white',
                        }}>
                        <PaymentAlert
                           actionPositive={isAlertTypePositive}
                           title={alertTitle}
                           message={alertMessage}
                           buttonText={alertButtonText}
                           onCallBack={alertCallBack}
                        />
                     </View>
                  </View>
               ) : (
                  <PaymentAlert
                     actionPositive={isAlertTypePositive}
                     title={alertTitle}
                     message={alertMessage}
                     buttonText={alertButtonText}
                     onCallBack={alertCallBack}
                  />
               ))}
            {alertMacOSVisible && (
               <TouchableOpacity
                  onPress={infoViewHidden}
                  style={{
                     position: 'absolute',
                     zIndex: 20,
                     justifyContent: 'center',
                     alignItems: 'center',
                     flex: 1,
                     backgroundColor: 'transparent',
                     width: '100%',
                     height: '100%',
                  }}>
                  <View
                     style={[
                        {position: 'absolute', left: alertMacX, top: alertMacY},
                        {width: 242, height: 181},
                     ]}>
                     <Image
                        source={require('../../assets/CVV.png')}
                        style={{width: 242, height: 181}}
                     />
                  </View>
               </TouchableOpacity>
            )}
            {isApiLoading && (
               <ActivityIndicator
                  size="large"
                  color={ActivityLoaderColor}
                  style={{
                     position: 'absolute',
                     top: 0,
                     bottom: 0,
                     left: 0,
                     right: 0,
                     zIndex: 1,
                  }}
               />
            )}
            <View
               style={{
                  // flexDirection: isLandscapemode ? 'row' : 'column',
                  backgroundColor: 'white',
                  alignItems: isLandscapemode || isWeb ? 'center' : null,
                  flex: 1,
                  justifyContent: 'center',
                  ...Platform.select({
                     web: {
                        flex: null,
                        height: windowDimensions.height - 104,
                     },
                  }),
               }}>
               {paymentStape >= 1 ? (
                  !isFreeCoursePayment && (
                     <View style={{alignItems: 'center'}}>
                        <PaymentStepsView completeSteps={paymentStape} />
                     </View>
                  )
               ) : (
                  <></>
               )}
               {paymentStape < 3 ? (
                  <ScrollView
                     style={{
                        paddingHorizontal: Platform.OS === 'windows' ? 18 : 20,
                        backgroundColor: appBackgroundWhiteBG,
                        flex: 1,
                        // marginTop: 16,
                        marginBottom: !isKeyboardVisible
                           ? isLandscapemode
                              ? 50
                              : 10
                           : 0,
                        maxWidth: 460,
                        //backgroundColor: 'white',
                     }}>
                     <View>
                        <Text
                           style={{
                              color: '#000000',
                              fontSize: 16,
                              fontFamily: FONT_FAMILY_REGULAR,
                              fontWeight: '700',
                              lineHeight: 28,
                              marginBottom: 16,
                              marginTop: paymentStape == 0 ? 32 : 0,
                           }}>
                           {paymentTitle}
                        </Text>
                        <View
                           style={{
                              backgroundColor: '#000000',
                              height: 2,
                              opacity: 0.1,
                           }}
                        />
                        <UserDetails userData={userAuthData} />
                        {/* {!isLandscapemode ? (
                        <UserDetails userData={userAuthData} />
                     ) : (
                        <></>
                     )} */}
                        {paymentStape == 0 ? (
                           <></>
                        ) : paymentStape == 1 ? (
                           <CardDetails
                              CardNumberError={isCardNumberError}
                              CardNameError={isCardNameError}
                              CardExpiryError={isCardExpryError}
                              CardCVVError={isCardCvvError}
                              cardName={name => {
                                 setCardHolderName(name);
                              }}
                              cardNumber={cNumber => {
                                 setCardNumber(cNumber);
                              }}
                              cardExpMonth={expMonth => {
                                 setCardMM(expMonth);
                              }}
                              cardExpYear={year => {
                                 setCardYY(year);
                              }}
                              cardCvvValue={cvv => {
                                 setCardCVV(cvv);
                              }}
                              alertShowForMac={infoViewShown}
                           />
                        ) : paymentStape == 2 ? (
                           <PaymentMethod
                              paymentDetails={{
                                 cardType: GetCardType(cardNumber),
                                 maskCardNo:
                                    'xxxx-xxxx-xxxx-' + cardNumber.slice(-4),
                                 expiry: `Ending ${cardMM}/${cardYY}`,
                              }}
                           />
                        ) : (
                           <></>
                        )}
                        <OderSummery
                           paymentStape={paymentStape}
                           screenMode={isLandscapemode}
                           courseItem={courseItem}
                           onCallBack={({type}) => {
                              if (type == FREE_COURSE) {
                                 setIsFreeCoursePayment(true);
                                 proceedPurchase({
                                    cardData: {
                                       CardHolderName: '',
                                       CardNumber: '',
                                       CardExpiry: '',
                                       CardCVV: '',
                                    },
                                    authData: userAuthData,
                                    courseItem: courseItem,
                                    processType: type,
                                 });
                              } else if (paymentStape == 0) {
                                 setPaymentStep(1);
                              } else if (paymentStape == 1) {
                                 setIsCardNumberError(false);
                                 setIsCardNameError(false);
                                 setIsCardExpiryError(false);
                                 setIsCardCvvError(false);
                                 if (cardHolderName.length == 0) {
                                    setIsCardNameError(true);
                                 } else if (cardNumber.length < 16) {
                                    setIsCardNumberError(true);
                                 } else if (
                                    cardMM.length == 0 ||
                                    cardYY.length == 0
                                 ) {
                                    setIsCardExpiryError(true);
                                 } else if (cardCVV.length <= 2) {
                                    setIsCardCvvError(true);
                                 } else {
                                    setPaymentTitle(Payment_Review);
                                    setPaymentStep(2);
                                 }
                              } else if (paymentStape == 2) {
                                 proceedPurchase({
                                    cardData: {
                                       CardHolderName: cardHolderName,
                                       CardNumber: cardNumber,
                                       CardExpiry: `${cardMM}${cardYY}`,
                                       CardCVV: cardCVV,
                                    },
                                    authData: userAuthData,
                                    courseItem: courseItem,
                                    processType: type,
                                 });
                              }
                           }}
                        />
                     </View>
                  </ScrollView>
               ) : (
                  <SuccessfullPayment
                     isOrientationLandscapemode={isLandscapemode}
                     onSuccess={() => {
                        navigation.pop(2);
                     }}
                  />
               )}

               {/* {isLandscapemode ? (
                  <View style={{ marginTop: 50, maxWidth: 423 }}>
                     <UserDetails userData={userAuthData} />
                  </View>
               ) : (
                  <></>
               )} */}
            </View>
            {isLandscapemode && (
               <View
                  style={{
                     position: isWeb ? 'fixed' : 'absolute',
                     height: 40,
                     bottom: 0,
                     left: 0,
                     right: 0,
                     paddingTop: 4,
                     paddingBottom: 6,
                     backgroundColor: appBackgroundWhiteBG,
                  }}>
                  <CopyRight
                     screenOrientation={isLandscapemode}
                     isCopyrightShown={!isKeyboardVisible}
                  />
               </View>
            )}
         </View>
      </KeyboardAvoidingView>
   );

   function proceedPurchase({cardData, authData, courseItem, processType}) {
      const reqBody = {
         EmployeeKey: authData.EmployeeKey,
         DistributionKey: authData.DistributionKey,
         CompanyKey: authData.CompanyKey,
         DepartmentKey: authData.DepartmentKey,
         EmployeeEmail: authData.EmployeeEmail,
         CardNumber: cardData.CardNumber,
         CardHolderName: cardData.CardHolderName,
         CardExpiry: cardData.CardExpiry,
         CardCVV: cardData.CardCVV,
         CourseRecordList: [
            {
               Key: courseItem.Key,
               Name: courseItem.Name,
               ID: courseItem.ID,
               Rate: courseItem.Rate,
               TaxCode: courseItem.TaxCode,
               TestEnabled: 'false',
            },
         ],
      };
      const reqParms = {
         theData: JSON.stringify(reqBody),
      };
      setIsApiLoading(true);
      apiPostRequest({url: PAYMENT_PROCESS, parms: reqParms})
         .then(res => {
            setIsApiLoading(false);
            if (res === undefined || res === null) {
               setShowAlert(false);
               return;
            }
            try {
               if (res.StatusResult) {
                  dispatch(setIsDashboardRefreshRequired(true));
                  setPaymentStep(3);
                  setPaymentTitle(Payment_cConfirmation);
                  // setAlertTitle('Purchase Successful');
                  // setAlertMessage(res.StatusMessage);
                  // setAlertButtonText('Confirm');
                  // setIsAlertTypePositive(true);
               } else if (typeof res !== 'string') {
                  setAlertTitle('Transaction Error!');
                  if (processType != FREE_COURSE) {
                     setPaymentStep(1);
                     setPaymentTitle(Payment_Details);
                  }
                  setAlertMessage(res.StatusMessage);
                  setAlertButtonText('OK');
                  setIsAlertTypePositive(false);
                  setShowAlert(true);
               } else {
                  setAlertTitle('Transaction Error!');
                  setAlertMessage(res);
                  if (processType != FREE_COURSE) {
                     setPaymentStep(1);
                     setPaymentTitle(Payment_Details);
                  }
                  setAlertButtonText('OK');
                  setIsAlertTypePositive(false);
                  setShowAlert(true);
               }
            } catch (e) {
               setAlertTitle('Transaction Error');
               setAlertMessage('Exception: ' + e.message);
               setAlertButtonText('OK');
               setIsAlertTypePositive(false);
               setShowAlert(true);
            }
         })
         .catch(error => {
            logger('error::', error);
         });
   }
   function onCallBack(params) {}
   function alertCallBack(params) {
      setShowAlert(false);
      if (isAlertTypePositive) {
         navigation.navigate('DashboardScreen');
      }
   }
};

const LandScapeModeHeader = probs => {
   const navigation = useNavigation();

   return (
      <View
         style={{
            height: 82,
            backgroundColor: '#001D4E',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: Platform.OS !== 'web' ? 10 : null,
         }}>
         <View
            style={{
               flexDirection: 'row',
               justifyContent: 'space-between',
               width: '100%',
               alignItems: 'center',
               padding: 16,
            }}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
               <Image
                  source={require('../../assets/lock_blue.png')}
                  style={{width: 24, height: 24}}
               />
               <Text
                  style={{
                     color: white,
                     marginLeft: 16,
                     fontSize: 24,
                     fontFamily: FONT_FAMILY_REGULAR,
                     fontWeight: '500',
                  }}>
                  Secure Checkout
               </Text>
            </View>
            <TouchableOpacity
               onPress={() => {
                  navigation.goBack();
               }}>
               <Image
                  source={require('../../assets/crossIconLandscape.png')}
                  style={{
                     width: 40,
                     height: 40,
                     marginTop: Platform.OS !== 'web' ? 12 : null,
                     marginRight: 4,
                  }}
               />
            </TouchableOpacity>
         </View>
      </View>
   );
};

const UserDetails = props => {
   const jsonObj = props.userData;
   const userDatatem = `${jsonObj.LastName}, ${jsonObj.FirstName}\n${
      jsonObj.CompanyName
   }\n\nEmail: ${jsonObj.EmailAddress}\nContact No: ${decodeURIComponent(
      jsonObj.PhoneNumber,
   )}\n\n`;

   return (
      <View
         style={{
            backgroundColor: '#F3F3F3',
            minHeight: 162,
            borderRadius: 8,
            marginTop: 16,
         }}>
         <Text
            style={{
               fontSize: 14,
               color: '#000000',
               fontFamily: FONT_FAMILY_BOLD,
               fontWeight: '700',
               marginTop: 16,
               marginLeft: 12,
            }}>
            Billing Details
         </Text>
         <View
            style={{
               height: 2,
               backgroundColor: '#000000',
               opacity: 0.1,
               marginLeft: 12,
               marginTop: 16,
               marginRight: 12,
            }}
         />
         <View
            style={{
               flexDirection: 'row',
               justifyContent: 'space-between',
            }}>
            <Text
               style={{
                  marginTop: 8,
                  marginLeft: 13,
                  width: '75%',
                  color: '#000000',
                  opacity: 0.6,
                  fontFamily: FONT_FAMILY_REGULAR,
                  fontWeight: '400',
               }}>
               {userDatatem}
            </Text>
            <Image
               source={require('../../assets/global_location.png')}
               style={{
                  width: 80,
                  height: 80,
                  justifyContent: 'center',
                  right: 0,
               }}
            />
         </View>
      </View>
   );
};

const CardDetails = props => {
   const [isCardHolderNameFocused, setIsCardHolderNameFocused] =
      useState(false);
   const [isCardNumberFocused, setIsCardNumberFocused] = useState(false);
   const [isMonthFocused, setIsMonthFocused] = useState(false);
   const [isYearFocused, setIsYearFocused] = useState(false);
   const [isCvvFocused, setIsCvvFocused] = useState(false);
   const isCardNumberError = props.CardNumberError;
   const isCardNameError = props.CardNameError;
   const isCardExpiryError = props.CardExpiryError;
   const isCardCVVError = props.CardCVVError;
   const [numericValue, setNumericValue] = useState('');
   const [cardExpMM, setCardExpMM] = useState('');
   const [cardExpYY, setCardExpYY] = useState('');
   const [cardCVV, setCardCVV] = useState('');
   const myRef = React.useRef(null);
   const myRefCvv = React.useRef(null);
   const [isHoverI, setHoverI] = useState(false);
   const borderCardHolderNameStyle = {
      borderTopWidth: isCardHolderNameFocused ? 0 : 1,
      borderRightWidth: isCardHolderNameFocused ? 0 : 1,
      borderLeftWidth: isCardHolderNameFocused ? 0 : 1,
      borderBottomWidth: isCardHolderNameFocused ? 3 : 1,
      borderColor: isCardNameError ? colorPrimaryError300 : '#AFBACA',
      borderRadius: isCardHolderNameFocused ? 0 : 6,
   };
   const borderCardNumberStyle = {
      borderTopWidth: isCardNumberFocused ? 0 : 1,
      borderRightWidth: isCardNumberFocused ? 0 : 1,
      borderLeftWidth: isCardNumberFocused ? 0 : 1,
      borderBottomWidth: isCardNumberFocused ? 3 : 1,
      borderColor: isCardNumberError ? colorPrimaryError300 : '#AFBACA',
      borderRadius: isCardNumberFocused ? 0 : 6,
   };
   const cardHolderNameHandleFocus = () => {
      setIsCardHolderNameFocused(true);
   };
   const cardHolderNameHandleBlur = () => {
      setIsCardHolderNameFocused(false);
   };
   const cardNumberHandleFocus = () => {
      setIsCardNumberFocused(true);
   };
   const cardNumberHandleBlur = () => {
      setIsCardNumberFocused(false);
   };
   const borderMonthStyle = {
      borderTopWidth: isMonthFocused ? 0 : 1,
      borderRightWidth: isMonthFocused ? 0 : 1,
      borderLeftWidth: isMonthFocused ? 0 : 1,
      borderBottomWidth: isMonthFocused ? 3 : 1,
      borderColor: isCardExpiryError ? colorPrimaryError300 : '#AFBACA',
      borderRadius: isMonthFocused ? 0 : 6,
   };
   // Month
   const mmHandleFocus = () => {
      setIsMonthFocused(true);
   };
   const mmHandleBlur = () => {
      setIsMonthFocused(false);
   };
   // YY
   const yyHandleFocus = () => {
      setIsYearFocused(true);
   };
   const yyHandleBlur = () => {
      setIsYearFocused(false);
   };
   const borderYearStyle = {
      borderTopWidth: isYearFocused ? 0 : 1,
      borderRightWidth: isYearFocused ? 0 : 1,
      borderLeftWidth: isYearFocused ? 0 : 1,
      borderBottomWidth: isYearFocused ? 3 : 1,
      borderColor: isCardExpiryError ? colorPrimaryError300 : '#AFBACA',
      borderRadius: isYearFocused ? 0 : 6,
   };
   //cvv
   const cvvHandleFocus = () => {
      setIsCvvFocused(true);
   };
   const cvvHandleBlur = () => {
      setIsCvvFocused(false);
   };
   const borderCvvStyle = {
      borderTopWidth: isCvvFocused ? 0 : 1,
      borderRightWidth: isCvvFocused ? 0 : 1,
      borderLeftWidth: isCvvFocused ? 0 : 1,
      borderBottomWidth: isCvvFocused ? 3 : 1,
      borderColor: isCardCVVError ? colorPrimaryError300 : '#AFBACA',
      borderRadius: isCvvFocused ? 0 : 6,
   };
   const [alertVisible, setAlertVisible] = useState(false);
   const [alertX, setAlertX] = useState(0);
   const [alertY, setAlertY] = useState(0);

   const showAlert = (x, y) => {
      setAlertX(x);
      setAlertY(y);
      setAlertVisible(true);
   };

   const closeAlert = () => {
      setAlertVisible(false);
   };
   return (
      <View>
         <View style={{flexDirection: 'row-reverse', flex: 1, marginTop: 8}}>
            <Image
               source={require('../../assets/cards.png')}
               style={{height: 24, width: 160}}
            />
         </View>
         <View>
            <Text
               style={[
                  styles.titleStyle,
                  {color: isCardNameError ? colorPrimaryError600 : 'black'},
               ]}>
               Cardholder Name
            </Text>
            <TextInput
               placeholder="Cardholder Name"
               placeholderTextColor={'#757575'}
               style={[
                  styles.inputStyle,
                  {
                     backgroundColor: isCardNameError
                        ? colorPrimaryError25
                        : '#F3F3F3',
                  },
                  {
                     color: isCardNameError ? colorPrimaryError600 : base100,
                  },
                  {
                     borderColor:
                        isCardHolderNameFocused && !isCardNameError
                           ? '#AFBACA'
                           : isCardNameError
                           ? colorPrimaryError300
                           : '#F3F3F3',
                  },
               ]}
               onChangeText={text => props.cardName(text)}
               onFocus={cardHolderNameHandleFocus}
               onBlur={cardHolderNameHandleBlur}
            />
            {isCardNameError ? (
               <Text style={styles.texErrorStyle}>
                  Please enter a valid name.
               </Text>
            ) : (
               <></>
            )}
         </View>
         <View>
            <Text
               style={[
                  styles.titleStyle,
                  {color: isCardNumberError ? colorPrimaryError600 : 'black'},
               ]}>
               Card Number
            </Text>
            <TextInput
               placeholder="Card Number"
               placeholderTextColor={'#757575'}
               keyboardType="numeric"
               maxLength={16}
               style={[
                  styles.inputStyle,
                  {
                     backgroundColor: isCardNumberError
                        ? colorPrimaryError25
                        : '#F3F3F3',
                  },
                  {
                     color: isCardNumberError ? colorPrimaryError600 : base100,
                  },
                  {
                     borderColor:
                        isCardNumberFocused && !isCardNumberError
                           ? '#AFBACA'
                           : isCardNumberError
                           ? colorPrimaryError300
                           : '#F3F3F3',
                  },
               ]}
               onChangeText={text => {
                  // Remove non-numeric characters
                  const sanitizedText = text.replace(/[^0-9]/g, '');
                  setNumericValue(sanitizedText);
                  props.cardNumber(sanitizedText);
               }}
               onFocus={cardNumberHandleFocus}
               onBlur={cardNumberHandleBlur}
               value={numericValue}
            />
            {isCardNumberError ? (
               <Text style={styles.texErrorStyle}>
                  Please enter a valid card number.
               </Text>
            ) : (
               <></>
            )}
         </View>
         <View
            style={{
               flexDirection: 'row',
               justifyContent: 'space-between',
               minWidth: 320,
            }}>
            <View style={{flex: 0.35}}>
               <Text
                  style={[
                     styles.titleStyle,
                     {
                        color: isCardExpiryError
                           ? colorPrimaryError600
                           : 'black',
                     },
                  ]}>
                  Card Expiry
               </Text>
               <View style={{flexDirection: 'row'}}>
                  <TextInput
                     placeholder="MM"
                     placeholderTextColor={'#757575'}
                     keyboardType="numeric"
                     maxLength={2}
                     style={[
                        styles.inputStyle,
                        {width: Platform.OS === 'windows' ? 64 : 60},
                        {
                           backgroundColor: isCardExpiryError
                              ? colorPrimaryError25
                              : '#F3F3F3',
                        },
                        {
                           color: isCardExpiryError
                              ? colorPrimaryError600
                              : base100,
                        },
                        {
                           borderColor:
                              isMonthFocused && !isCardExpiryError
                                 ? '#AFBACA'
                                 : isCardExpiryError
                                 ? colorPrimaryError300
                                 : '#F3F3F3',
                        },
                     ]}
                     onChangeText={text => {
                        const numericText = text.replace(/[^0-9]/g, '');
                        setCardExpMM(numericText);
                        props.cardExpMonth(numericText);
                     }}
                     onFocus={mmHandleFocus}
                     onBlur={mmHandleBlur}
                     value={cardExpMM}
                  />
                  <Text
                     style={{
                        marginTop: 10,
                        marginHorizontal: 5,
                        fontSize: 26,
                        color: 'black',
                     }}>
                     /
                  </Text>
                  <TextInput
                     placeholder="YY"
                     placeholderTextColor={'#757575'}
                     keyboardType="numeric"
                     maxLength={2}
                     style={[
                        styles.inputStyle,
                        {width: Platform.OS === 'windows' ? 64 : 60},
                        {
                           backgroundColor: isCardExpiryError
                              ? colorPrimaryError25
                              : '#F3F3F3',
                        },
                        {
                           color: isCardExpiryError
                              ? colorPrimaryError600
                              : base100,
                        },
                        {
                           borderColor:
                              isYearFocused && !isCardExpiryError
                                 ? '#AFBACA'
                                 : isCardExpiryError
                                 ? colorPrimaryError300
                                 : '#F3F3F3',
                        },
                     ]}
                     onChangeText={text => {
                        const numericText = text.replace(/[^0-9]/g, '');
                        setCardExpYY(numericText);
                        props.cardExpYear(numericText);
                     }}
                     onFocus={yyHandleFocus}
                     onBlur={yyHandleBlur}
                     value={cardExpYY}
                  />
               </View>
               {isCardExpiryError ? (
                  <Text style={styles.texErrorStyle}>Invalid expiry date.</Text>
               ) : (
                  <></>
               )}
            </View>
            {Platform.OS === 'windows' ? (
               <Popup
                  isOpen={alertVisible}
                  isLightDismissEnabled={true}
                  target={myRefCvv.current}
                  horizontalOffset={-242}
                  verticalOffset={-195}
                  onDismiss={() => {
                     closeAlert();
                  }}>
                  <TouchableOpacity style={{flex: 1}}>
                     <View style={[{width: 242, height: 181}]}>
                        <Image
                           source={require('../../assets/CVV.png')}
                           style={{width: 242, height: 181}}
                        />
                     </View>
                  </TouchableOpacity>
               </Popup>
            ) : Platform.OS !== 'macos' ? (
               <CustomAlert
                  visible={alertVisible}
                  x={alertX}
                  y={alertY}
                  onClose={closeAlert}
               />
            ) : null}
            <View style={{flex: 0.55}}>
               <Text
                  style={[
                     styles.titleStyle,
                     {color: isCardCVVError ? colorPrimaryError600 : 'black'},
                     isMacOS && {
                        marginLeft: 39,
                     },
                  ]}>
                  Security Code (CVV)
               </Text>
               {Platform.OS === 'windows' ? (
                  <View
                     style={[
                        {
                           flexDirection: 'row',
                           alignItems: 'center',
                        },
                        styles.cvvInputStyleForWindows,
                        {
                           backgroundColor: isCardCVVError
                              ? colorPrimaryError25
                              : '#F3F3F3',
                           borderColor:
                              isCvvFocused && !isCardCVVError
                                 ? '#AFBACA'
                                 : isCardCVVError
                                 ? colorPrimaryError300
                                 : '#F3F3F3',
                        },
                     ]}>
                     <TextInput
                        placeholder="CVV"
                        placeholderTextColor={'#757575'}
                        keyboardType="numeric"
                        maxLength={4}
                        style={[
                           {
                              flex: 1,
                              borderColor: '#F3F3F3',
                              borderWidth: 0,
                              padding: 10,
                              fontWeight: '700',
                              fontFamily: FONT_FAMILY_REGULAR,
                           },

                           {
                              backgroundColor: isCardCVVError
                                 ? colorPrimaryError25
                                 : '#F3F3F3',
                           },
                        ]}
                        onChangeText={text => {
                           const numericText = text.replace(/[^0-9]/g, '');
                           setCardCVV(numericText);
                           props.cardCvvValue(numericText);
                        }}
                        onFocus={cvvHandleFocus}
                        onBlur={cvvHandleBlur}
                        value={cardCVV}
                     />
                     <TouchableOpacity
                        onMouseEnter={() => setHoverI(true)}
                        onMouseLeave={() => setHoverI(false)}
                        ref={myRefCvv}
                        onPress={event => {
                           if (Platform.OS === 'macos') {
                              props.alertShowForMac(event);
                           } else {
                              const x = event.nativeEvent.pageX - 225;
                              const y = event.nativeEvent.pageY - 180;
                              showAlert(x, y);
                           }
                        }}>
                        <Image
                           source={require('../../assets/alert_circle.png')}
                           style={[
                              {
                                 width: 24,
                                 height: 24,
                                 marginEnd: 5,
                              },
                              isHoverI && {tintColor: primaryColor500},
                           ]}
                        />
                     </TouchableOpacity>
                  </View>
               ) : (
                  <View
                     style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                     }}>
                     <TextInput
                        placeholder="CVV"
                        placeholderTextColor={'#757575'}
                        keyboardType="numeric"
                        maxLength={4}
                        TextWrapping="Wrap"
                        style={[
                           styles.inputStyle,
                           {flex: isMacOS ? 0.8 : 1},
                           {
                              backgroundColor: isCardCVVError
                                 ? colorPrimaryError25
                                 : '#F3F3F3',
                           },
                           {
                              color: isCardCVVError
                                 ? colorPrimaryError600
                                 : base100,
                           },
                           {
                              borderColor:
                                 isCvvFocused && !isCardCVVError
                                    ? '#AFBACA'
                                    : isCardCVVError
                                    ? colorPrimaryError300
                                    : '#F3F3F3',
                           },
                        ]}
                        onChangeText={text => {
                           const numericText = text.replace(/[^0-9]/g, '');
                           setCardCVV(numericText);
                           props.cardCvvValue(numericText);
                        }}
                        onFocus={cvvHandleFocus}
                        onBlur={cvvHandleBlur}
                        value={cardCVV}
                     />
                     <TouchableOpacity
                        onMouseEnter={() => setHoverI(true)}
                        onMouseLeave={() => setHoverI(false)}
                        style={{
                           position: 'absolute',
                           backgroundColor:
                              Platform.OS === 'windows' ? '#F3F3F3' : null,
                        }}
                        ref={myRef}
                        onPress={event => {
                           if (Platform.OS === 'macos') {
                              props.alertShowForMac(event);
                           } else {
                              const x = event.nativeEvent.pageX - 225;
                              const y = event.nativeEvent.pageY - 180;
                              showAlert(x, y);
                           }
                        }}>
                        <Image
                           source={require('../../assets/alert_circle.png')}
                           style={[
                              {
                                 width: 24,
                                 height: 24,
                                 marginEnd: 10,
                                 marginTop: 8,
                              },
                              isHoverI && {tintColor: primaryColor500},
                           ]}
                        />
                     </TouchableOpacity>
                  </View>
               )}
               {isCardCVVError ? (
                  <Text style={styles.texErrorStyle}>Invalid CVV.</Text>
               ) : (
                  <></>
               )}
            </View>
         </View>
      </View>
   );
};

const OderSummery = props => {
   const isLandscapemode = props.screenMode;
   const isFreeCouse = props.courseItem.Rate === 0 ? true : false;
   const [isHover, setHover] = useState(false);
   let buttontext =
      props.paymentStape === 0
         ? 'Confirm Purchase'
         : props.paymentStape === 1
         ? 'Review Your Order'
         : 'Submit Your Order';
   buttontext = isFreeCouse ? 'Submit Your Order' : buttontext;
   return (
      <View>
         <View
            style={{
               flexDirection: 'row',
               justifyContent: 'space-between',
               alignItems: 'center',
               marginTop: 16,
            }}>
            <Text
               style={{
                  color: 'black',
                  fontWeight: '700',
                  fontSize: 16,
                  fontFamily: FONT_FAMILY_REGULAR,
               }}>
               Order Summary
            </Text>
            <View
               style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
               }}>
               <Image
                  source={require('../../assets/lock_.png')}
                  style={{width: 12, height: 12, marginRight: 8}}
               />
               <Text
                  style={{
                     color: '#000000',
                     fontWeight: '700',
                     fontSize: 10,
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  Secure Checkout
               </Text>
            </View>
         </View>
         <View
            style={{
               minHeight: 201,
               backgroundColor: '#F3F3F3',
               borderRadius: 8,
               marginTop: 8,
               marginBottom: isLandscapemode ? (!isWeb ? 50 : 0) : 30,
            }}>
            <View style={{margin: 16}}>
               <View
                  style={{
                     flexDirection: 'row',
                     alignItems: 'center',
                     justifyContent: 'space-between',
                  }}>
                  <Text
                     style={{
                        flex: 3,
                        color: '#000000',
                        fontWeight: '400',
                        fontSize: 14,
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {props.courseItem.Name}
                  </Text>
                  <Text
                     style={{
                        flex: 2,
                        textAlign: 'right',
                        color: '#000000',
                        fontWeight: '700',
                        fontSize: isFreeCouse ? 24 : 14,
                        // marginRight: 10,
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {isFreeCouse
                        ? 'FREE'
                        : currencyConverter(
                             props.courseItem.Rate,
                             'USD',
                             'es-US',
                          )}
                  </Text>
               </View>
               <View
                  style={{
                     height: 2,
                     backgroundColor: '#000000',
                     opacity: 0.1,
                     marginTop: 10,
                     marginBottom: 10,
                  }}
               />
               <View
                  style={{
                     flexDirection: 'row',
                     alignItems: 'center',
                     justifyContent: 'space-between',
                  }}>
                  <Text
                     style={{
                        color: '#000000',
                        fontWeight: '500',
                        fontSize: 14,
                        fontFamily: FONT_FAMILY_SEMI_BOLD,
                     }}>
                     Total Tax
                  </Text>
                  <Text
                     style={{
                        color: '#000000',
                        fontWeight: '500',
                        fontSize: 14,
                        // marginRight: 10,
                        fontFamily: FONT_FAMILY_SEMI_BOLD,
                     }}>
                     {isFreeCouse ? '---' : taxPrice(props.courseItem)}
                  </Text>
               </View>
               <View
                  style={{
                     height: 2,
                     backgroundColor: '#000000',
                     opacity: 0.1,
                     marginTop: 10,
                     marginBottom: 10,
                  }}
               />
               <View
                  style={{
                     flexDirection: 'row',
                     alignItems: 'center',
                     justifyContent: 'space-between',
                     marginBottom: -10,
                  }}>
                  <Text
                     style={{
                        color: '#000000',
                        fontWeight: '700',
                        fontSize: 14,
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     Total
                  </Text>
                  <Text
                     style={{
                        color: '#000000',
                        fontWeight: '700',
                        fontSize: 24,
                        // marginRight: 10,
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {isFreeCouse ? '' : totalPrice(props.courseItem)}
                  </Text>
               </View>
            </View>
            <View
               style={{
                  flex: 1,
                  flexDirection: isLandscapemode ? 'row-reverse' : 'column',
               }}>
               <TouchableOpacity
                  onPress={() => {
                     const processType = isFreeCouse
                        ? FREE_COURSE
                        : props.paymentStape;
                     props.onCallBack(isFreeCouse ? {type: processType} : '');
                  }}
                  style={{
                     justifyContent: 'center',
                     alignItems: 'center',
                     backgroundColor: isHover
                        ? BUTTON_HOVER_COLOR
                        : primaryColor500,
                     minHeight: 44,
                     borderRadius: 8,
                     margin: 16,
                     minWidth: 200,
                     marginBottom: 16,
                  }}
                  onMouseEnter={() => {
                     setHover(true);
                  }}
                  onMouseLeave={() => {
                     setHover(false);
                  }}>
                  <Text
                     style={{
                        color: white,
                        fontSize: 14,
                        fontWeight: '500',
                        fontFamily: FONT_FAMILY_MEDIUM,
                     }}>
                     {buttontext}
                  </Text>
               </TouchableOpacity>
            </View>
         </View>
      </View>
   );
   function totalPrice(params) {
      const totalPrice = params.Rate + params.Rate * (params.TaxRate / 100);
      return currencyConverter(totalPrice, 'USD', 'en-us');
   }
   function taxPrice(params) {
      const totalPrice = params.Rate * (params.TaxRate / 100);
      if (totalPrice === 0) {
         return '---';
      }
      return currencyConverter(totalPrice, 'USD', 'en-us');
   }
};
const PaymentMethod = props => {
   const jsonObj = props.paymentDetails;
   const paymentMethod = `${jsonObj.cardType}\n${jsonObj.maskCardNo}\n${jsonObj.expiry}\n`;

   return (
      <View
         style={{
            backgroundColor: '#F3F3F3',
            minHeight: 162,
            // maxWidth: 342,
            maxHeight: 190,
            borderRadius: 8,
            marginTop: 16,
         }}>
         <Text
            style={{
               fontSize: 14,
               color: '#000000',
               fontFamily: FONT_FAMILY_BOLD,
               fontWeight: '700',
               marginTop: 16,
               marginLeft: 12,
            }}>
            Payment Method
         </Text>
         <View
            style={{
               height: 2,
               backgroundColor: '#000000',
               opacity: 0.1,
               marginLeft: 12,
               marginTop: 16,
               marginRight: 12,
            }}
         />
         <View>
            <View>
               <Text
                  style={{
                     marginTop: 8,
                     marginLeft: 13,
                     color: '#000000',
                     opacity: 0.6,
                     fontFamily: FONT_FAMILY_REGULAR,
                     fontWeight: '400',
                  }}>
                  {paymentMethod}
               </Text>
            </View>
         </View>
      </View>
   );
};
const SuccessfullPayment = props => {
   const [isHover, setHover] = useState(false);

   return (
      <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
         <View style={{alignItems: 'center', marginBottom: 200}}>
            <Image
               source={require('../../assets/tick_with_green_bg.png')}
               style={{width: 96, height: 96, margin: 24}}
            />
            <Text
               style={{
                  fontFamily: FONT_FAMILY_REGULAR,
                  fontWeight: '700',
                  color: '#000000',
                  fontSize: 24,
                  textAlign: 'center',
                  marginBottom: 8,
               }}>
               Thank you for your order!
            </Text>
            <Text
               style={{
                  fontFamily: FONT_FAMILY_REGULAR,
                  fontWeight: '500',
                  color: '#000000',
                  fontSize: 14,
                  textAlign: 'center',
               }}>
               {'A confirmation email will be sent to \nyour inbox.'}
            </Text>
         </View>
         <View
            style={{
               position: 'absolute',
               bottom: 0,
               left: 0,
               right: 0,
               alignItems: 'center',
            }}>
            <TouchableOpacity
               onMouseEnter={() => setHover(true)}
               onMouseLeave={() => setHover(false)}
               style={[
                  {
                     width: props.isOrientationLandscapemode ? 380 : 311,
                     height: 48,
                     borderRadius: 8,
                     backgroundColor: '#003DA5',
                     alignItems: 'center',
                     justifyContent: 'center',
                     marginBottom: props.isOrientationLandscapemode ? 46 : 32,
                  },
                  isHover && {backgroundColor: BUTTON_HOVER_COLOR},
               ]}
               onPress={() => {
                  props.onSuccess();
               }}>
               <Text
                  style={[
                     {
                        fontFamily: FONT_FAMILY_REGULAR,
                        fontWeight: '500',
                        color: '#FFFFFF',
                        fontSize: 14,
                        textAlign: 'center',
                     },
                     isHover && {color: WHITE_TEXT_HOVER_COLOR},
                  ]}>
                  Browse Courses
               </Text>
            </TouchableOpacity>
         </View>
      </View>
   );
};
const styles = StyleSheet.create({
   container: {
      backgroundColor: appBackgroundWhiteBG,
      flex: Platform.OS !== 'web' ? 1 : null,
   },
   titleStyle: {
      fontSize: 12,
      marginTop: 16,
      color: '#3D4A5C',
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   texErrorStyle: {
      fontSize: 12,
      color: 'red',
      fontWeight: '400',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   inputStyle: {
      width: '100%',
      backgroundColor: white,
      marginTop: 8,
      borderWidth: Platform.OS !== 'windows' ? 1 : null,
      paddingHorizontal: 14,
      borderColor: '#AFBACA',
      borderRadius: 6,
      fontSize: 14,
      padding: 10,
      textAlignVertical: 'center',
      color: base100,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   cvvInputStyleForWindows: {
      width: '100%',
      backgroundColor: white,
      marginTop: 8,
      borderWidth: Platform.OS !== 'windows' ? 1 : 1,
      borderColor: '#AFBACA',
      borderRadius: 6,
      fontSize: 14,
      height: 40,
      textAlignVertical: 'center',
      color: base100,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
});
